import React from "react";
import { Col, Typography } from "antd";
import CollectionFileIcon from "../../../assets/icons/collection-file.svg";
import CollectionPriceIcon from "../../../assets/icons/collection-price.svg";
import { ICollections } from "../../../helpers/types";

interface Props {
  collection: ICollections;
  handleNavigation: (id: string) => void;
}

const CollectionItem: React.FC<Props> = ({ collection, handleNavigation }) => {
  return (
    <Col
      className="collection-item"
      span={8}
      onClick={() => {
        handleNavigation(collection._id);
      }}
    >
      <div className="collection-box">
        <img className="collection-img" src={collection.thumbnail} alt="collection" />
        <div className={`${collection.price === undefined ? "d-none" : ""} overlay-left`}>
          <img src={CollectionPriceIcon} className="overlay-icon" alt="price" />
          <span className="overlay-text">{collection.price} €</span>
        </div>
        <div className="overlay-right">
          <img src={CollectionFileIcon} className="overlay-icon" alt="files" />
          <span className="overlay-text">{collection.filesCount}</span>
        </div>
        <div className="overlay-bottom">
          <div className="collection-description-container">
            <Typography.Text className="collection-description-text">{collection.title}</Typography.Text>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default CollectionItem;
